/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveTagFilterRequest model module.
 * @module model/SaveTagFilterRequest
 * @version V1
 */
class SaveTagFilterRequest {
    /**
     * Constructs a new <code>SaveTagFilterRequest</code>.
     * @alias module:model/SaveTagFilterRequest
     * @param name {String} 
     * @param tagIds {Array.<Number>} 
     */
    constructor(name, tagIds) { 
        
        SaveTagFilterRequest.initialize(this, name, tagIds);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, tagIds) { 
        obj['name'] = name;
        obj['tagIds'] = tagIds;
    }

    /**
     * Constructs a <code>SaveTagFilterRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveTagFilterRequest} obj Optional instance to populate.
     * @return {module:model/SaveTagFilterRequest} The populated <code>SaveTagFilterRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveTagFilterRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('tagIds')) {
                obj['tagIds'] = ApiClient.convertToType(data['tagIds'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SaveTagFilterRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SaveTagFilterRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SaveTagFilterRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['tagIds'])) {
            throw new Error("Expected the field `tagIds` to be an array in the JSON data but got " + data['tagIds']);
        }

        return true;
    }


}

SaveTagFilterRequest.RequiredProperties = ["name", "tagIds"];

/**
 * @member {String} name
 */
SaveTagFilterRequest.prototype['name'] = undefined;

/**
 * @member {Array.<Number>} tagIds
 */
SaveTagFilterRequest.prototype['tagIds'] = undefined;






export default SaveTagFilterRequest;

